import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Models(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (this.filteringService.models().length < 1) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  if (!listing.model?.id) {
    return false;
  }

  // Determine if the listing matches the filter.
  const _models = this.filteringService
    .models()
    .toString()
    .split('-')
    .filter((term) => term.trim() !== '');

  for (const _model of _models) {
    if (!listing.model.id.toLowerCase().includes(_model.toLowerCase())) {
      return false;
    }
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
